import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { WaveSliders } from '../interactions/WaveSliders.jsx'
import { CardHistoryBack } from '../interactions/CardHistoryBack.jsx'
import { useCardHistory } from '../interactions/useCardHistory.js'

const CARD_DEF = { id: 'prep-clarity', icon: '◎', label: 'Clarity check' }

// Three sliders — shared WaveSliders with clarity-specific fields
const CLARITY_FIELDS = [
  { key: 'priorities', label: 'Priorities', color: 'var(--moss-500)',    bg: 'var(--moss-100)' },
  { key: 'role',       label: 'Role',       color: 'var(--clay-600)',    bg: 'var(--clay-100)' },
  { key: 'strategy',   label: 'Strategy',   color: 'var(--mustard-500)', bg: 'var(--mustard-200)' },
]

/**
 * ClarityCard — three sliders (priorities / role / strategy) with auto-unfurl
 * 'what's foggy?' under the lowest-value slider.
 * catalog #21, prep-clarity. Shape-shift: drops ClarityRingsScale, reuses WaveSliders.
 */
export function ClarityCard({ card, value, onChange, disabled, ownerUserId }) {
  const { data: historyData, loading: historyLoading, error: historyError } = useCardHistory(card?.prepCardId ?? 'prep-clarity', ownerUserId)

  const back = (
    <CardHistoryBack
      cardDef={CARD_DEF}
      entries={historyData?.entries ?? []}
      loading={historyLoading}
      error={historyError}
      onFlip={() => {}}
    />
  )

  const hasFill = CLARITY_FIELDS.some((f) => (value ?? {})[f.key] != null)

  return (
    <CardFrame
      kind="prep"
      icon="◎"
      iconClass="moss"
      title="Clarity check"
      prompt="How clear are your priorities, role, and strategy?"
      state={disabled ? 'locked' : hasFill ? 'filled' : 'empty'}
      back={back}
      data-testid="prep-card-prep-clarity"
      className="prepcard"
    >
      <WaveSliders
        fields={CLARITY_FIELDS}
        values={value ?? {}}
        onChange={onChange}
        disabled={disabled}
        unfurlLowest
        unfurlPlaceholder="What's foggy here?"
      />
    </CardFrame>
  )
}
